export default "__VITE_ASSET__D$ONgCmR__"